export const getPhone = async (givenPhone = null) => {
  let rawPhoneNumber = givenPhone || window.localStorage.getItem("hub-phone");
  let phoneNumber = (rawPhoneNumber || "").replace(/-/g, " ");
  if (phoneNumber.length === 0) {
    rawPhoneNumber = window.prompt(
      "Enter your phone number (for verification)",
      "+11234567890"
    );

    phoneNumber = (rawPhoneNumber || "").replace(/-/g, " ");
  }
  if (phoneNumber.substring(0, 2) !== "+1") {
    phoneNumber = `+1${phoneNumber}`;
  }
  window.localStorage.setItem("hub-phone", phoneNumber);
  return phoneNumber;
};
